import { Color } from "@client/style";
import { css } from "@emotion/css";
import { Space } from "antd";
import { adjustHue, rgba } from "polished";
import React from "react";

export function MapItemContent({ data, desc }: { data: { label: string; value: string | number }[]; desc?: string }) {
  return (
    <>
      <Space
        direction="vertical"
        size="large"
        className={css`
          font-size: 1.8rem;
          position: relative;
          left: -4rem;
        `}
      >
        {data.map(({ label, value }, i) => (
          <div key={label}>
            <label
              className={css`
                display: inline-block;
                width: 16rem;
                text-align: right;
                font-weight: bold;
                font-size: 1.8rem !important;
                padding-right: 2rem;
                color: ${adjustHue(-45 * i, Color.main)};
              `}
            >
              {label}&nbsp;：
            </label>
            <span>{value}</span>
          </div>
        ))}
      </Space>
      {desc && (
        <div
          className={css`
            width: 100%;
            margin-top: 2rem;
            padding: 2rem;
            border-radius: 0.5rem;
            background: ${rgba(Color.main, 0.05)};
            font-family: sans-serif;
            font-size: 1.2rem;
          `}
        >
          {desc}
        </div>
      )}
    </>
  );
}
